import React from 'react';
import { Mail } from 'lucide-react';
import './Footer.css';

const Footer = ({ theme = 'dark', variant = 'default' }) => {
  return (
    <footer className={`footer ${theme}`}>
      <div className="footer-container">
        <div className="footer-section">
          <h3 className="footer-title">ConvoCue AI</h3>
          <p className="footer-description">
            {variant === 'assistant' ? 'Master your professional calls' : 'Land your dream job in less than 50 days'}
          </p>
        </div>

        <div className="footer-section">
          {/*<h4 className="footer-subtitle">Follow Us</h4>*/}
          {/*<div className="social-icons">*/}
          {/*  <a*/}
          {/*    href="https://www.xiaohongshu.com/user/profile/656e0a9f0000000020030ce5?xhsshare=CopyLink&appuid=5dedebd5000000000100bad1&apptime=1724823578&share_id=fc85ab3ea79847b598c9bb766f97bb01"*/}
          {/*    aria-label="Xiaohongshu"*/}
          {/*    target="_blank"*/}
          {/*    rel="noopener noreferrer"*/}
          {/*  >*/}
          {/*    <img src={xhs} alt="Xiaohongshu" style={{ width: 25, height: 25 }} />*/}
          {/*  </a>*/}
          {/*  <a*/}
          {/*    href="https://www.instagram.com/convocue_ai?igsh=ZzY5d3ZjdnB0dW83&utm_source=qr"*/}
          {/*    aria-label="Instagram"*/}
          {/*    target="_blank"*/}
          {/*    rel="noopener noreferrer"*/}
          {/*  >*/}
          {/*    <Instagram size={24} />*/}
          {/*  </a>*/}
          {/*  <a*/}
          {/*    href="https://www.tiktok.com/@convocue?_t=8pEzr23Hw0E&_r=1"*/}
          {/*    aria-label="TikTok"*/}
          {/*    target="_blank"*/}
          {/*    rel="noopener noreferrer"*/}
          {/*  >*/}
          {/*    <img src={tiktok} alt="TikTok" style={{ width: 25, height: 25 }} />*/}
          {/*  </a>*/}
          {/*</div>*/}
        </div>

        <div className="footer-section">
          <h4 className="footer-subtitle">Contact</h4>
          <a href="mailto:customer@convocue.tech" className="contact-email">
            <Mail size={18} />
            <span>customer@convocue.tech</span>
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} ConvoCue INC. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
